import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoiginImage from '../../assets/images/reset_password.png';
import Logo from '../../assets/images/logo_image.png';
import { ValidateResetPassword } from '../../assets/validation';
import AuthAction from '../../store/actions/AuthAction';
import LinkExpired from '../../utils/errorPages/LinkExpired';
import Loader from '../../utils/errorPages/Loader';

function SetPassword() {
  const dispatch = useDispatch();
  const { code, key } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (code && key) {
      dispatch(AuthAction.getSetPassword(code, key));
    }
  }, [dispatch, code, key]);

  const { verifyLinkStatus, isLoading } = useSelector((state) => state.authentication);

  if (verifyLinkStatus === true) {
    return (
      <Box className="invoiceAppLoginWrap">
        {isLoading === true ? <Loader /> : false}
        <Grid container spacing={2}>
          <Grid item xs={6} md={6}>
            <Box className="loginLeftBg">
              <img src={LoiginImage} alt="Login" />
            </Box>
          </Grid>
          <Grid item xs={6} md={6}>
            <Box className="loginRightForm">
              <Box
                className="loginFormWrap"
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh'
                }}
              >
                <Formik
                  initialValues={{
                    password: '',
                    password_confirmation: '',
                    token: code,
                    email: key
                  }}
                  enableReinitialize
                  validationSchema={ValidateResetPassword}
                  onSubmit={(values, { setErrors, setSubmitting }) => {
                    dispatch(AuthAction.setPassword(values, setErrors, setSubmitting, navigate));
                  }}
                >
                  {({
                    errors,
                    touched,
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <img src={Logo} alt="Logo" />
                      <Box className="logninInner">
                        <Typography variant="h3" gutterBottom component="" mb={2}>
                          Set Password
                        </Typography>
                        {/* <Typography
                          variant="body1"
                          align="center"
                          className="subtitle"
                          component="p"
                          mb={2}>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                          tempor incididunt ut labore et dolore magna aliqua.
                        </Typography> */}
                        <Paper elevation={0} sx={{ background: 'none' }}>
                          <TextField
                            id="filled-password-input"
                            fullWidth
                            variant="outlined"
                            label="New Password"
                            name="password"
                            type="password"
                            margin="normal"
                            placeholder="Enter New Password"
                            error={errors.password && touched.password}
                            value={values.password}
                            // onChange={handleChange}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            helperText={errors.password && touched.password && errors.password}
                            required={false}
                            InputLabelProps={{ required: true }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    disabled
                                    sx={{
                                      bgcolor: 'secondary.main',
                                      '&.Mui-disabled': {
                                        bgcolor: 'secondary.main'
                                      },
                                      '&:hover': {
                                        borderColor: 'secondary.main',
                                        borderWidth: '1px',
                                        borderStyle: 'solid'
                                      }
                                    }}
                                    color="white"
                                  >
                                    <i className="icon-password" />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                          <TextField
                            id="filled-password-input"
                            fullWidth
                            variant="outlined"
                            label="Confrim Password"
                            name="password_confirmation"
                            type="password"
                            margin="normal"
                            placeholder="Enter Confrim Password"
                            error={errors.password_confirmation && touched.password_confirmation}
                            value={values.password_confirmation}
                            // onChange={handleChange}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            helperText={
                              errors.password_confirmation &&
                              touched.password_confirmation &&
                              errors.password_confirmation
                            }
                            required={false}
                            InputLabelProps={{ required: true }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="start">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    disabled
                                    sx={{
                                      bgcolor: 'secondary.main',
                                      '&.Mui-disabled': {
                                        bgcolor: 'secondary.main'
                                      },
                                      '&:hover': {
                                        borderColor: 'secondary.main',
                                        borderWidth: '1px',
                                        borderStyle: 'solid'
                                      }
                                    }}
                                    color="white"
                                  >
                                    <i className="icon-password" />
                                  </IconButton>
                                </InputAdornment>
                              )
                            }}
                          />
                          <Button
                            type="submit"
                            className="submit_btn"
                            variant="contained"
                            sx={{ mt: 5, mb: 1 }}
                            fullWidth
                            color="secondary"
                            size="large"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                          </Button>
                        </Paper>
                      </Box>
                    </form>
                  )}
                </Formik>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }
  if (verifyLinkStatus === false) {
    return (
      <div>
        {isLoading === true ? <Loader /> : false}
        <LinkExpired />
      </div>
    );
  }
  return <div>{isLoading === true ? <Loader /> : false}</div>;
}

export default SetPassword;
